import GameRecord   from '../records/game'
import * as Actions from '../actions/game'

const GameStore = {

  getInitialState() {
    return new GameRecord({ loading: true })
  },

  setGame(_, params) {
    return new GameRecord(params)
  },

  register() {
    return {
      [Actions.createGame] : this.setGame,
      [Actions.updateGame] : this.setGame
    }
  }

}

export default GameStore



/** WEBPACK FOOTER **
 ** ./web/static/app/stores/game.js
 **/